import {
  AsyncSelectFieldProps,
  DEFAULT_SELECT_PAGE_PARAM,
  useAsyncQuerySelect,
} from 'components/form/field/select/useAsyncQuerySelect'
import { SelectField } from 'components/form/final-form'
import { AtividadeColetivaGrupoSelectDocument } from 'graphql/hooks.generated'
import {
  AtividadeColetivaGrupoSelectQuery,
  AtividadeColetivaGrupoSelectQueryVariables,
  TipoGrupoParticipanteAtividadeColetivaEnum,
} from 'graphql/types.generated'
import React from 'react'

import { AtividadeColetivaGrupoSelectItem } from './AtividadeColetivaGrupoSelectItem'
import { convertToAtividadeColetivaGrupoSelectFieldModel } from './converter-atividadeColetivaGruposSelect'
import {
  AtividadeColetivaGrupoItemModel,
  AtividadeColetivaGrupoSelectItemModel,
} from './model-atividadeColetivaGrupoSelectField'

interface AtividadeColetivaGruposSelectFieldProps extends AsyncSelectFieldProps<AtividadeColetivaGrupoSelectItemModel> {
  tipoGrupo: TipoGrupoParticipanteAtividadeColetivaEnum
}

export function AtividadeColetivaGruposSelectField(props: Readonly<AtividadeColetivaGruposSelectFieldProps>) {
  const { tipoGrupo, ...rest } = props

  const {
    selectProps: { items, ...asyncPropsRest },
  } = useAsyncQuerySelect<
    AtividadeColetivaGrupoSelectItemModel,
    AtividadeColetivaGrupoSelectQuery,
    AtividadeColetivaGrupoSelectQueryVariables
  >({
    query: AtividadeColetivaGrupoSelectDocument,
    extractItems: convertToAtividadeColetivaGrupoSelectFieldModel,
    variables: (inputString) => ({
      input: {
        nomeGrupo: inputString,
        isAtivo: true,
        isSomenteMeusGrupos: false,
        tipoGrupo: tipoGrupo,
        pageParams: {
          ...DEFAULT_SELECT_PAGE_PARAM,
          sort: ['nome'],
        },
      },
    }),
  })

  const itemToString = (item: AtividadeColetivaGrupoItemModel) => {
    if (!item) return null

    return `${item.nome} | ${item.unidadeDeSaude}`
  }

  return (
    <SelectField<AtividadeColetivaGrupoSelectItemModel>
      itemToString={itemToString}
      icon='zoomOutline'
      items={items}
      iconPosition='left'
      placeholder='Busque por um grupo de participantes'
      components={{
        Item: AtividadeColetivaGrupoSelectItem,
      }}
      {...asyncPropsRest}
      {...rest}
    />
  )
}
